import { Box, Typography } from "@material-ui/core"
import React from "react"
import "../MobilePreview.scss"

const DidYouKnow = ({ data }) => {
  return (
    <div>
      <Box className="mobile-preview__did-you-know">
        <Typography variant="h2" align="center" className="mobile-preview__did-you-know-title">
          DID YOU KNOW ?
        </Typography>

        <Box
          className="mobile-preview__cards-container"
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "12px",
            overflowX: "auto",
            overflowY: "hidden",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
            p: 0
          }}>
          {data?.map((item, index) => (
            <Box
              key={index}
              className="mobile-preview__card"
              sx={{
                minWidth: "250px",
                borderRadius: 2,
                overflow: "hidden",
                flexShrink: 0,
                position: "relative"
              }}>
              <Box
                className="mobile-preview__card-image-placeholder"
                sx={{
                  width: "100%",
                  height: "160px",
                  backgroundImage: `url(${item?.image?.url})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat"
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: 6,
                  left: 6,
                  right: 6,
                  p: 3,
                  borderRadius: "6px",
                  background: "rgba(20, 13, 13, 0.80)",
                  backdropFilter: "blur(9px)",
                  gap: "16px",
                  display: "grid"
                }}>
                <Typography
                  variant="body2"
                  style={{
                    color: "#FFF",
                    fontFamily: "Solare-Bold",
                    fontSize: "18px",
                    fontStyle: "normal",
                    fontWeight: 900,
                    lineHeight: "120%",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase"
                  }}>
                  {item?.title}
                </Typography>
                <Typography
                  variant="body2Regular"
                  style={{
                    color: "#fff",
                    fontFamily: "Inter-Regular",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "144%",
                    maxHeight: "75px",
                    overflow: "auto",
                    msOverflowStyle: "none",
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                      display: "none"
                    }
                  }}>
                  {item?.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </div>
  )
}

export default DidYouKnow
